import(/* webpackMode: "eager" */ "/app/frontend/src/app/global-error.tsx");
